/* ============================================================
   WISENT FULLSCREEN IMAGE VIEWER
   Markup: snippets/wisent-lightbox.liquid
   Styles: assets/wisent-lightbox.css
   ============================================================ */

(function () {
  var FOCUSABLE = 'a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])';
  var MAX_SCALE = 4;
  var ZOOM_SCALE = 2.5;

  function clamp(value, min, max) {
    return Math.min(Math.max(value, min), max);
  }

  function initLightbox(lightbox) {
    if (lightbox.dataset.wlbBound === 'true') return;
    lightbox.dataset.wlbBound = 'true';

    var stage = lightbox.querySelector('[data-wlb-stage]');
    var slides = Array.prototype.slice.call(lightbox.querySelectorAll('[data-wlb-slide]'));
    var thumbs = Array.prototype.slice.call(lightbox.querySelectorAll('[data-wlb-thumb]'));
    var currentEl = lightbox.querySelector('[data-wlb-current]');
    var prevBtn = lightbox.querySelector('[data-wlb-prev]');
    var nextBtn = lightbox.querySelector('[data-wlb-next]');
    var count = slides.length;

    var index = 0;
    var scrollY = 0;
    var lastFocus = null;

    // ---------- zoom state, per slide ----------

    var zoom = slides.map(function () {
      return { scale: 1, x: 0, y: 0 };
    });

    function applyTransform(i) {
      var state = zoom[i];
      var inner = slides[i].querySelector('[data-wlb-zoom]');
      inner.style.transform =
        'translate(' + state.x + 'px, ' + state.y + 'px) scale(' + state.scale + ')';
      state.applied = state.scale;
      slides[i].classList.toggle('is-zoomed', state.scale > 1);
      lightbox.classList.toggle('is-zoomed', zoom[index].scale > 1);
    }

    // Keep the image from being dragged off screen. The limit depends on
    // how big the image actually is, not how big the slide is — a wide
    // photo in a wide viewport may still fit horizontally at 2.5x.
    function clampOffsets(i) {
      var state = zoom[i];
      var img = slides[i].querySelector('.wlb__image');
      if (!img) return;

      var slideRect = slides[i].getBoundingClientRect();
      var imgRect = img.getBoundingClientRect();
      var applied = state.applied || 1;

      // imgRect is measured with whatever transform is currently applied,
      // so convert back to 1x and then up to the scale we are heading for
      var width = (imgRect.width / applied) * state.scale;
      var height = (imgRect.height / applied) * state.scale;

      var overflowX = Math.max(0, (width - slideRect.width) / 2);
      var overflowY = Math.max(0, (height - slideRect.height) / 2);

      state.x = clamp(state.x, -overflowX, overflowX);
      state.y = clamp(state.y, -overflowY, overflowY);
    }

    function resetZoom(i) {
      zoom[i] = { scale: 1, x: 0, y: 0 };
      applyTransform(i);
    }

    function zoomTo(i, scale, originX, originY) {
      var state = zoom[i];
      var rect = slides[i].getBoundingClientRect();
      var next = clamp(scale, 1, MAX_SCALE);

      if (next === 1) {
        resetZoom(i);
        return;
      }

      // keep the point under the cursor/finger where it was
      var cx = originX - rect.left - rect.width / 2;
      var cy = originY - rect.top - rect.height / 2;
      var ratio = next / state.scale;

      state.x = (state.x - cx) * ratio + cx;
      state.y = (state.y - cy) * ratio + cy;
      state.scale = next;

      applyTransform(i);
      clampOffsets(i);
      applyTransform(i);
    }

    // ---------- navigation ----------

    function setIndex(i, behavior) {
      index = clamp(i, 0, count - 1);
      if (currentEl) currentEl.textContent = String(index + 1);
      thumbs.forEach(function (thumb) {
        thumb.classList.toggle('is-active', Number(thumb.dataset.index) === index);
      });
      if (prevBtn) prevBtn.disabled = index === 0;
      if (nextBtn) nextBtn.disabled = index === count - 1;

      var activeThumb = thumbs[index];
      if (activeThumb && activeThumb.scrollIntoView) {
        activeThumb.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: behavior || 'smooth' });
      }
      lightbox.classList.toggle('is-zoomed', zoom[index].scale > 1);
    }

    function goTo(i, behavior) {
      var target = clamp(i, 0, count - 1);
      resetZoom(index);
      stage.scrollTo({ left: slides[target].offsetLeft, behavior: behavior || 'smooth' });
      setIndex(target, behavior);
    }

    var scrollTimer = null;
    stage.addEventListener(
      'scroll',
      function () {
        if (zoom[index].scale > 1) return;
        clearTimeout(scrollTimer);
        scrollTimer = setTimeout(function () {
          var nearest = Math.round(stage.scrollLeft / stage.clientWidth);
          if (nearest !== index) setIndex(nearest);
        }, 60);
      },
      { passive: true }
    );

    if (prevBtn) prevBtn.addEventListener('click', function () { goTo(index - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { goTo(index + 1); });

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        goTo(Number(thumb.dataset.index));
      });
    });

    // ---------- pointer: pan, pinch, double-tap ----------

    var pointers = new Map();
    var panStart = null;
    var pinchStart = null;
    var dragged = false;

    slides.forEach(function (slide, i) {
      slide.addEventListener('pointerdown', function (event) {
        pointers.set(event.pointerId, { x: event.clientX, y: event.clientY });

        if (pointers.size === 1) dragged = false;

        if (pointers.size === 2) {
          var pts = Array.from(pointers.values());
          pinchStart = {
            distance: Math.hypot(pts[0].x - pts[1].x, pts[0].y - pts[1].y) || 1,
            scale: zoom[i].scale,
            midX: (pts[0].x + pts[1].x) / 2,
            midY: (pts[0].y + pts[1].y) / 2
          };
          panStart = null;
          dragged = true;
          slide.classList.remove('is-panning');
          slide.classList.add('is-pinching');
          return;
        }

        if (zoom[i].scale > 1) {
          slide.setPointerCapture(event.pointerId);
          slide.classList.add('is-panning');
          panStart = { x: event.clientX, y: event.clientY, ox: zoom[i].x, oy: zoom[i].y };
        }
      });

      slide.addEventListener('pointermove', function (event) {
        if (!pointers.has(event.pointerId)) return;
        pointers.set(event.pointerId, { x: event.clientX, y: event.clientY });

        if (pinchStart && pointers.size === 2) {
          var pts = Array.from(pointers.values());
          var distance = Math.hypot(pts[0].x - pts[1].x, pts[0].y - pts[1].y);
          zoomTo(i, pinchStart.scale * (distance / pinchStart.distance), pinchStart.midX, pinchStart.midY);
          return;
        }

        if (!panStart) return;

        event.preventDefault();
        var dx = event.clientX - panStart.x;
        var dy = event.clientY - panStart.y;
        if (Math.hypot(dx, dy) > 5) dragged = true;

        zoom[i].x = panStart.ox + dx;
        zoom[i].y = panStart.oy + dy;
        clampOffsets(i);
        applyTransform(i);
      });

      function endPointer(event) {
        pointers.delete(event.pointerId);

        if (pointers.size < 2) {
          pinchStart = null;
          slide.classList.remove('is-pinching');
        }

        if (pointers.size === 0) {
          panStart = null;
          slide.classList.remove('is-panning');
          if (zoom[i].scale <= 1) resetZoom(i);
        }
      }

      slide.addEventListener('pointerup', endPointer);
      slide.addEventListener('pointercancel', endPointer);

      slide.addEventListener('click', function (event) {
        // a click always follows a drag or a pinch — ignore that one
        if (dragged) {
          dragged = false;
          return;
        }

        // Zoomed in: any click zooms back out. This has to be checked
        // before looking at event.target, because while panning the slide
        // holds pointer capture and the click is retargeted to the slide
        // rather than the image.
        if (zoom[i].scale > 1) {
          resetZoom(i);
          return;
        }

        if (event.target.closest('.wlb__image')) {
          zoomTo(i, ZOOM_SCALE, event.clientX, event.clientY);
          return;
        }

        close();
      });

      slide.addEventListener('dblclick', function (event) {
        event.preventDefault();
      });
    });

    // ---------- open / close ----------

    function lockScroll() {
      scrollY = window.scrollY;
      document.body.style.position = 'fixed';
      document.body.style.top = '-' + scrollY + 'px';
      document.body.style.left = '0';
      document.body.style.right = '0';
      document.body.style.width = '100%';
    }

    function unlockScroll() {
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.left = '';
      document.body.style.right = '';
      document.body.style.width = '';
      window.scrollTo(0, scrollY);
    }

    function open(startIndex) {
      lastFocus = document.activeElement;
      lightbox.hidden = false;
      lockScroll();

      // jump without animating, before the fade-in
      requestAnimationFrame(function () {
        goTo(startIndex || 0, 'auto');
        lightbox.classList.add('is-open');
        var closeBtn = lightbox.querySelector('[data-wlb-close]');
        if (closeBtn) closeBtn.focus();
      });
    }

    function close() {
      lightbox.classList.remove('is-open');
      unlockScroll();
      slides.forEach(function (slide, i) { resetZoom(i); });
      setTimeout(function () {
        lightbox.hidden = true;
      }, 180);
      if (lastFocus && typeof lastFocus.focus === 'function') lastFocus.focus();
    }

    lightbox.addEventListener('click', function (event) {
      if (event.target.closest('[data-wlb-close]')) close();
    });

    document.addEventListener('keydown', function (event) {
      if (lightbox.hidden) return;

      if (event.key === 'Escape') {
        if (zoom[index].scale > 1) {
          resetZoom(index);
        } else {
          close();
        }
        return;
      }

      if (event.key === 'ArrowLeft') {
        event.preventDefault();
        goTo(index - 1);
        return;
      }

      if (event.key === 'ArrowRight') {
        event.preventDefault();
        goTo(index + 1);
        return;
      }

      if (event.key !== 'Tab') return;

      var items = Array.prototype.filter.call(
        lightbox.querySelectorAll(FOCUSABLE),
        function (el) { return el.offsetParent !== null; }
      );
      if (!items.length) return;

      var first = items[0];
      var last = items[items.length - 1];

      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    });

    window.addEventListener('resize', function () {
      if (lightbox.hidden) return;
      slides.forEach(function (slide, i) { resetZoom(i); });
      stage.scrollTo({ left: slides[index].offsetLeft, behavior: 'auto' });
    });

    // ---------- triggers on the product page ----------

    var product = document.querySelector('[data-wp-amazon-product]');
    if (!product) return;

    function openFromProduct() {
      var activeThumb = product.querySelector('[data-wp-thumb].is-active');
      open(activeThumb ? Number(activeThumb.dataset.index) : 0);
    }

    product.querySelectorAll('[data-wlb-open]').forEach(function (trigger) {
      trigger.addEventListener('click', openFromProduct);
      trigger.addEventListener('keydown', function (event) {
        if (event.key !== 'Enter' && event.key !== ' ') return;
        event.preventDefault();
        openFromProduct();
      });
    });
  }

  function boot(scope) {
    (scope || document).querySelectorAll('[data-wlb]').forEach(initLightbox);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(); });
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) { boot(event.target); });
})();